import { Lifecycle, SimMetadataKey } from "../decorators/SimDecorator.js";
import { ReflectUtils } from "@dooboostore/core";
import { ValidUtils } from "@dooboostore/core";
class SimAtomic {
  constructor(type, simstanceManager, config) {
    this.type = type;
    this.simstanceManager = simstanceManager;
    this.config = config;
    this.value = type.value;
  }
  getConfig(key = SimMetadataKey) {
    return ReflectUtils.getMetadata(key, this.type.originalType);
  }
  getConfigs() {
    return ReflectUtils.getMetadatas(this.type.originalType);
  }
  getValue(config) {
    if (config?.refresh) {
      this.value = void 0;
    }
    if (!this.value) {
      if (typeof this.type.targetKeyType === "symbol") {
        const stored = this.simstanceManager.getStoreSet(this.type.targetKeyType);
        if (ValidUtils.isArrowFunction(stored?.instance)) {
          const fresh = stored.instance();
          if (this.getConfig()?.scope === Lifecycle.Singleton) {
            this.simstanceManager.setStoreSet(this.type.targetKeyType, fresh, stored.type);
            this.value = fresh;
          }
          return fresh;
        }
        this.value = stored?.instance;
      } else {
        this.value = this.simstanceManager.getOrNewSim({ target: this.type.targetKeyType, originTypeTarget: this.type.originalType, newInstanceCarrier: config?.newInstanceCarrier });
      }
    }
    return this.value;
  }
}
export {
  SimAtomic
};
//# sourceMappingURL=SimAtomic.js.map
